import { useEffect, useRef } from 'react';

/* ── Mini-canvas simulating 5 SOC screens ── */
const SCREENS = [
  // Oscilloscope
  (ctx, w, h, t) => {
    ctx.strokeStyle = 'rgba(0,200,83,0.7)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    for (let x = 0; x < w; x++) {
      const y = h / 2 + Math.sin((x + t * 2) * 0.15) * (h * 0.3);
      x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
    }
    ctx.stroke();
  },
  // Matrice de points
  (ctx, w, h, t) => {
    const cols = 8, rows = 5;
    const dx = w / (cols + 1), dy = h / (rows + 1);
    for (let r = 1; r <= rows; r++) {
      for (let c = 1; c <= cols; c++) {
        const bright = Math.sin(t * 0.03 + r * c) * 0.5 + 0.5;
        ctx.fillStyle = `rgba(0,200,83,${0.2 + bright * 0.6})`;
        ctx.beginPath();
        ctx.arc(c * dx, r * dy, 1.5, 0, Math.PI * 2);
        ctx.fill();
      }
    }
  },
  // Equalizer
  (ctx, w, h, t) => {
    const bars = 10;
    const bw = w / (bars * 2);
    for (let i = 0; i < bars; i++) {
      const bh = (Math.sin(t * 0.04 + i * 0.8) * 0.5 + 0.5) * h * 0.8;
      ctx.fillStyle = `rgba(0,200,83,${0.4 + (bh / h) * 0.5})`;
      ctx.fillRect(i * bw * 2 + bw * 0.5, h - bh, bw, bh);
    }
  },
  // Mini radar
  (ctx, w, h, t) => {
    const cx = w / 2, cy = h / 2, r = Math.min(w, h) * 0.4;
    ctx.strokeStyle = 'rgba(0,200,83,0.3)';
    ctx.lineWidth = 0.5;
    [0.3, 0.6, 1].forEach(s => {
      ctx.beginPath();
      ctx.arc(cx, cy, r * s, 0, Math.PI * 2);
      ctx.stroke();
    });
    const angle = t * 0.03;
    ctx.strokeStyle = 'rgba(0,200,83,0.7)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(cx, cy);
    ctx.lineTo(cx + Math.cos(angle) * r, cy + Math.sin(angle) * r);
    ctx.stroke();
  },
  // Sinusoide
  (ctx, w, h, t) => {
    ctx.strokeStyle = 'rgba(0,150,255,0.6)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    for (let x = 0; x < w; x++) {
      const y = h / 2 + Math.sin((x - t * 1.5) * 0.12) * (h * 0.25)
        + Math.cos((x - t) * 0.08) * (h * 0.15);
      x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
    }
    ctx.stroke();
  },
];

export default function SocScreens() {
  const refs = [useRef(), useRef(), useRef(), useRef(), useRef()];
  const frameRef = useRef(0);

  useEffect(() => {
    let running = true;
    let t = 0;

    function draw() {
      if (!running) return;
      t++;
      refs.forEach((ref, i) => {
        const cvs = ref.current;
        if (!cvs) return;
        const ctx = cvs.getContext('2d');
        const w = cvs.width, h = cvs.height;
        ctx.clearRect(0, 0, w, h);
        SCREENS[i](ctx, w, h, t);
      });
      frameRef.current = requestAnimationFrame(draw);
    }
    draw();

    return () => {
      running = false;
      cancelAnimationFrame(frameRef.current);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="lg-screens-row">
      {SCREENS.map((_, i) => (
        <div className="lg-screen-wrap" key={i}>
          <canvas ref={refs[i]} width={72} height={44} className="lg-screen-canvas" />
        </div>
      ))}
      {/* Silhouettes operateurs */}
      <svg className="lg-operators" viewBox="0 0 400 30">
        {[80, 200, 320].map((x, i) => (
          <g key={i} opacity="0.25">
            <circle cx={x} cy="10" r="5" fill="#fff" />
            <path d={`M${x - 10},30 Q${x - 6},16 ${x},16 Q${x + 6},16 ${x + 10},30`} fill="#fff" />
          </g>
        ))}
      </svg>
    </div>
  );
}
